<app-aggregated-amount-item
  name="Shazam"
  icon="./assets/shazam.png"
  amount="{{ (shazams$ | async)?.units }}"
  unit="Shazam数"
  [rate]="(shazams$ | async)?.rate"
  [link]=""
  [hasAmount]="(shazams$ | async)?.hasUnits"
  help="{{
    (selectedArtist$ | async)?.nameMain
  }} のShazam数です。Shazam数は選択期間内の合計数です。"
  [loading]="loading$ | async"
  [dataCollections]="dataCollections$ | async"
  [dataCollectLoading]="dataCollectLoading$ | async"
></app-aggregated-amount-item>
